<agr-form-dialog
  [formGroup]="formGroup"
  [contentSpacing]="false"
  [data]="data"
  (confirm)="process()"
  (cancel)="cancel()"
  (alt)="alt()"
>
  <div class="dialog-content">
    @if (products.length > 0) {
      <mat-accordion>
        @for (product of products; track product.cropAid.id; let productIndex = $index) {
          <mat-expansion-panel
            #panel
            [expanded]="isPanelExpanded(product.cropAid.id)"
            (opened)="onPanelOpened(product.cropAid.id)"
            (closed)="onPanelClosed(product.cropAid.id)"
          >
            <mat-expansion-panel-header class="custom-header">
              <div class="header-row-container">
                <div class="header-row">
                  <div class="product-header">
                    <div class="icon-container">
                      <img
                        class="package-icon"
                        src="../../../../assets/icons/package.svg"
                        height="24"
                        width="24"
                        alt="GBM product icon"
                      />
                    </div>
                    <strong>{{ product.cropAid.name }}</strong>
                  </div>
                </div>

                @if (!panel.expanded) {
                  <div class="header-row">
                    <div class="header-summary">
                      <div class="summary-item">
                        <span class="label">{{ 'report.requisite' | translate }}</span>
                        <span class="value-bold"
                          >{{ product.requisiteAmount | agrNumber: '1.0-2' }}
                          {{ product.cropAid.unitOfMeasurement }}</span
                        >
                      </div>
                      <div class="summary-item">
                        <span class="label">{{ 'report.productInventory' | translate }}</span>
                        <span class="value-bold"
                          >{{ product.customerProductInventoryAmount | agrNumber: '1.0-2' }}
                          {{ product.cropAid.unitOfMeasurement }}</span
                        >
                      </div>
                      <div class="summary-item">
                        <span class="label">{{ 'report.order' | translate }}</span>
                        <span class="value-bold"
                          >{{ product.orderLinesTotalAmount | agrNumber: '1.0-2' }}
                          {{ product.cropAid.unitOfMeasurement }}</span
                        >
                      </div>
                      <div class="summary-item">
                        <span class="label">{{ 'report.difference' | translate }}</span>
                        <span
                          class="value-bold"
                          [ngClass]="{
                            'value-negative': isNegative(
                              getDifference(
                                product.requisiteAmount,
                                product.customerProductInventoryAmount,
                                product.orderLinesTotalAmount
                              )
                            ),
                          }"
                        >
                          {{
                            getDifference(
                              product.requisiteAmount,
                              product.customerProductInventoryAmount,
                              product.orderLinesTotalAmount
                            ) | agrNumber: '1.0-2'
                          }}
                          {{ product.cropAid.unitOfMeasurement }}
                        </span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="summary-section">
                <div class="summary-row">
                  <span class="summary-label">{{ 'report.requisite' | translate }}:</span>
                  <span class="summary-value"
                    >{{ product.requisiteAmount | agrNumber: '1.0-2' }} {{ product.cropAid.unitOfMeasurement }}</span
                  >
                </div>
                <div class="summary-row">
                  <span class="summary-label">{{ 'report.stock' | translate }}:</span>
                  <div class="summary-value editable-stock">
                    <mat-form-field appearance="outline" class="stock-input">
                      <input
                        matInput
                        type="number"
                        [formControl]="getStockControl(product.formIndex)"
                        step="0.01"
                        min="0"
                        [attr.data-test]="'product-inventory-dialog-input-' + product.formIndex"
                      />
                    </mat-form-field>
                    <span class="stock-unit">{{ product.cropAid.unitOfMeasurement }}</span>
                  </div>
                </div>
                <div class="summary-row">
                  <span class="summary-label">{{ 'report.orderTitle' | translate }}:</span>
                  <span class="summary-value positive"
                    >{{ product.orderLinesTotalAmount | agrNumber: '1.0-2' }}
                    {{ product.cropAid.unitOfMeasurement }}</span
                  >
                </div>
                <div class="summary-row">
                  <span class="summary-label">{{ 'report.difference' | translate }}:</span>
                  <span
                    class="summary-value"
                    [ngClass]="{
                      negative:
                        getDifference(
                          product.requisiteAmount,
                          product.customerProductInventoryAmount,
                          product.orderLinesTotalAmount
                        ) < 0,
                      positive:
                        getDifference(
                          product.requisiteAmount,
                          product.customerProductInventoryAmount,
                          product.orderLinesTotalAmount
                        ) >= 0,
                    }"
                    >{{
                      getDifference(
                        product.requisiteAmount,
                        product.customerProductInventoryAmount,
                        product.orderLinesTotalAmount
                      ) | agrNumber: '1.0-2'
                    }}
                    {{ product.cropAid.unitOfMeasurement }}</span
                  >
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    } @else {
      <div class="no-data">
        <span class="no-data-text">{{ 'report.noProductsInInventory' | translate }}</span>
      </div>
    }
  </div>
</agr-form-dialog>
